import { createStyles } from "@mantine/core";

export const useStyles = createStyles((theme) => ({
  description: {
    textAlign: "center",
    margin: "0 24px",
  },
}));
